//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
export default {
	name: 'line-chart',
	props: ['data', 'isNegative', 'timeframe', 'pair', 'theme'],
	data: () => ({}),
	mounted() {},
	computed: {
		gradientFill() {
			return this.theme === 'light'
				? {
						colors: this.chartColor,
						type: 'gradient',
						gradient: {
							shadeIntensity: 0.9,
							opacityFrom: 0.9,
							opacityTo: 0.9,
							stops: [0, 100, 100],
						},
				  }
				: { colors: this.chartColor }
		},
		chartColor() {
			return this.isNegative ? ['#ff7888'] : ['#728EFC']
		},
		chartData() {
			return [
				{
					name: '',
					data: this.data.map((el) => [el.y, parseFloat(el.x)]),
				},
			]
		},
		chartOptions() {
			return {
				chart: {
					id: 'area-datetime',
					height: '250px',
					zoom: {
						autoScaleYaxis: true,
					},
					background: '#fff',
					type: 'area',
					foreColor: '#666',
					fontFamily: 'Helvetica, Arial, sans-serif',
					zoom: {
						enabled: false,
					},
				},
				dataLabels: {
					enabled: false,
				},

				stroke: {
					curve: 'smooth',
					lineCap: 'butt',
					dashArray: 0,
					colors: this.chartColor,
					width: 3,
				},
				grid: {
					row: {
						opacity: 0,
					},
				},
				markers: {
					size: 0,
					style: 'hollow',
				},

				tooltip: {
					enabled: true,
					fillSeriesColor: false,
					theme: this.theme,
					style: {
						fontSize: '14px',
					},
					x: {
						show: true,
						format: 'dd MMM, HH:MM',
					},
					// y: {
					// 	title: {
					// 		formatter: (price) => `${this.pair}${price}`
					// 	},
					// },
					marker: {
						show: false,
					},
				},

				fill: this.gradientFill,
				yaxis: {
					show: false,
					showAlways: false,
				},
				xaxis: {
					type: 'datetime',
					tickAmount: 6,
					labels: {
						rotate: 0,
					},
				},
			}
		},
	},
}
